/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PatchTargetsRequest } from '../models/PatchTargetsRequest';
import type { Target } from '../models/Target';
import type { UpsertGraphRequest } from '../models/UpsertGraphRequest';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class TargetsService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * List the current user's targets
     * @returns Target Targets
     * @throws ApiError
     */
    public getTargets(): CancelablePromise<Array<Target>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/targets',
            errors: {
                401: `Unauthorized`,
            },
        });
    }

    /**
     * Update multiple targets
     * @returns Target Updated
     * @throws ApiError
     */
    public patchTargets({
        requestBody,
    }: {
        requestBody: PatchTargetsRequest,
    }): CancelablePromise<Array<Target>> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/targets',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                404: `No targets found to update`,
            },
        });
    }

    /**
     * Delete a target
     * @returns void
     * @throws ApiError
     */
    public deleteTargets({
        id,
    }: {
        id: string,
    }): CancelablePromise<void> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/targets/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                404: `Target not found`,
            },
        });
    }

    /**
     * Get a single target with program and assessment details
     * @returns Target Target
     * @throws ApiError
     */
    public getTargets1({
        id,
    }: {
        id: string,
    }): CancelablePromise<Target> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/targets/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                404: `Target not found`,
            },
        });
    }

    /**
     * Mark a target as completed
     * @returns Target Updated target
     * @throws ApiError
     */
    public postTargetsComplete({
        id,
    }: {
        id: string,
    }): CancelablePromise<Target> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/targets/{id}/complete',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                404: `Target not found`,
            },
        });
    }

    /**
     * Link a program to one or more targets
     * @returns any Linked
     * @throws ApiError
     */
    public postProgramsTargets({
        programId,
        requestBody,
    }: {
        programId: string,
        requestBody: {
            targetIds: Array<string>;
        },
    }): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/programs/{programId}/targets',
            path: {
                'programId': programId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                404: `Program not found`,
            },
        });
    }

    /**
     * Replace entire target DAG (immutable graph)
     * @returns any Graph persisted
     * @throws ApiError
     */
    public postTargetsGraph({
        requestBody,
    }: {
        requestBody: UpsertGraphRequest,
    }): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/targets/graph',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

}
